<template>

  <div class="bg-gradient absoluteFlexCenter d-flex flex-column">

    <div v-if="showQRCode" class="absoluteFlexCenter">
      <h5 class="text-white mb-4">請使用手機掃描，獲得最佳效果</h5>
      <img class="rounded-3" :src="qrCodeDataUrl" alt="QR Code" v-if="qrCodeDataUrl != ''"/>
    </div>

    <div v-else id="liff" class="flex-1 d-flex flex-column mx-auto">
      
      <!-- loading spinner -->
      <div v-if="isLoading && !gameStats.current_multiplier" class="absoluteFlexCenter">
        <div class="spinner-border text-white mb-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span class="text-white small">載入中...</span>
      </div>

      <div v-else id="lucky-wheel" ref="luckyWheel">
        <!-- back btn -->
        <div v-if="showReward"
          class="modal-header position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 h-42 py-0 px-3 lh-1 text-white bg-primary-mix-white-40"
          type="button"
          @click="handleClose"
        >
          <svg width="28" height="28"><use xlink:href="#back"/></svg>
          <div class="position-absolute start-0 end-0 flexCenter"><b>返回</b></div>
        </div>

        <!-- 遊戲畫面 -->
        <div v-if="!showReward" class="flex-1 w-100 d-flex flex-column">
          
          <!-- header -->
          <!-- <div class="position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 pb-1">
            <div class="h-header w-100 d-flex align-items-center ps-4 pe-3">
              <header class="flex-grow-1 fs-6 text-muted d-flex align-items-center justify-content-center">
                <b>幸運轉盤</b>
              </header>
            </div>
          </div> -->

          <!-- content -->
          <div class="wheel-wrapper">
            <div class="lucky-wheel-container">
              <header class="text-tertiary fs-3 my-3 flexCenter">
                <img src="@/assets/img/star-1.svg" width="50" height="33.33"/>
                <div class="mx-2"><b>小美幸運星輪盤</b></div>
                <img src="@/assets/img/star-1.svg" style="transform: scaleX(-1);" width="50" height="33.33"/>
              </header>

              <!-- 活動結束 -->
              <div class="finished py-4"><div class="bgCenterContain"></div></div>
              <div class="wheel-container pb-4">
                <p class="text-center text-white">
                  <b>活動已圓滿結束，謝謝您的熱情參與！</b>
                </p>
              </div>
              
              <!-- <div class="wheel-container"> -->
                <!-- 這裡是獎品扇區 -->
                <!-- <svg
                  id="lucky-wheel-content"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  viewBox="0 0 540 540"
                  width="540"
                  height="540" :style="{ transform: `rotate(${rotation}deg)` }"
                >
                  <g> -->
                    <!-- 這裡是每個獎品扇區的內容 -->
                    <!-- <g id="1_">
                      <path id="path" d="M328.7131446,89.299208l-58.7132667,180.7008542"/>
                      <path class="st13" d="M396.9614815,95.2524579c-35.6396484-25.9384766-79.5089111-41.2525635-126.9615479-41.2525635v216l126.9615479-174.7474365Z"/>
                      <circle class="st7" cx="320.8763579" cy="113.4179662" r="27"/>
                      <text class="st9" transform="translate(326.8594649 95.0059344) rotate(18)"><tspan x="0" y="0">1</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="2_">
                      <path id="path1" d="M423.7131294,158.3206918l-153.7133277,111.6792697"/>
                      <path class="st6" d="M475.4279612,203.2523382c-13.5868273-41.9331281-40.0764119-80.1081903-78.4664014-108.0001503l-126.9616145,174.7476708,205.4280159-66.7475204Z"/>
                      <circle class="st7" cx="403.1963854" cy="173.2268295" r="27"/>
                      <text class="st11" transform="translate(383.9482274 164.3025668) rotate(54.0000007)"><tspan x="0" y="0">10</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path1"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="3_">
                      <path id="path2" d="M459.9999212,269.9998353h-190.0001221"/>
                      <path class="st13" d="M475.4279399,336.7475162c13.6557001-41.91075,14.6639146-88.3652112.0002434-133.4953506l-205.4282075,66.7476708,205.4279641,66.7476798Z"/>
                      <path class="st7" d="M461.6399187,269.9997144c0,14.9116882-12.0883118,27-27,27-14.9116882,0-27-12.0883118-27-27s12.0883118-27,27-27c14.9116882,0,27,12.0883118,27,27Z"/>
                      <text class="st9" transform="translate(454.000148 270.0002512) rotate(90.0000007)"><tspan x="0" y="0">1</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path2"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="4_">
                      <path id="path3" d="M423.713199,381.6790013l-153.7133277-111.6792697"/>
                      <path class="st1" d="M396.9614258,444.7473714c35.6822142-25.8798898,63.803124-62.8697249,78.4667952-107.9998642l-205.4282075-66.7476708,126.9614123,174.747535Z"/>
                      <circle class="st7" cx="403.196597" cy="366.7726681" r="27"/>
                      <text class="st9" transform="translate(418.8595313 378.1526193) rotate(125.9999993)"><tspan x="0" y="0">3</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path3"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="5_">
                      <path id="path4" d="M328.7132572,450.7005444l-58.7132667-180.7008542"/>
                      <path fill="#2972fa" d="M269.9999603,485.9996299c44.0793352.0362086,88.5717087-13.3601405,126.9616983-41.2521005l-126.9616145-174.7476708-.0000838,215.9997713Z"/>
                      <text class="st10">
                        <textPath xlink:href="#path4"><tspan class="st8"><tspan x="0" y="0">再玩一次</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="6_">
                      <path id="path5" d="M211.2868447,450.700581l58.7132666-180.7008542"/>
                      <path class="st0" d="M143.0385079,444.747331c35.6396484,25.9384766,79.5089111,41.2525635,126.9615479,41.2525635v-216s-126.9615479,174.7474365-126.9615479,174.7474365Z"/>
                      <circle class="st7" cx="219.1236314" cy="426.5818228" r="27"/>
                      <text class="st9" transform="translate(213.1407987 444.9949158) rotate(-162)"><tspan x="0" y="0">5</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path5"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="7_">
                      <path id="path6" d="M116.28686,381.6790971l153.7133277-111.6792697"/>
                      <path class="st13" d="M64.5720281,336.7474508c13.5868273,41.9331281,40.0764119,80.1081903,78.4664014,108.0001503l126.9616145-174.7476708-205.4280159,66.7475205Z"/>
                      <circle class="st7" cx="136.8036039" cy="366.7729594" r="27"/>
                      <text class="st9" transform="translate(121.140685 378.1532832) rotate(-125.9999993)"><tspan x="0" y="0">1</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path6"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="8_">
                      <path id="path7" d="M80.0000681,269.9999537h190.0001221"/>
                      <path class="st1" d="M64.5720494,203.2522728c-13.6557001,41.91075-14.6639146,88.3652112-.0002434,133.4953506l205.4282075-66.7476708-205.4279641-66.7476798Z"/>
                      <circle class="st7" cx="105.3600706" cy="270.0000745" r="27"/>
                      <text class="st9" transform="translate(85.9993221 270.0007212) rotate(-89.9999993)"><tspan x="0" y="0">3</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path7"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="9_">
                      <path id="path8" d="M116.2867904,158.3207876l153.7133277,111.6792697"/>
                      <path class="st13" d="M143.0385635,95.2524175c-35.6822142,25.8798898-63.803124,62.8697249-78.4667952,107.9998642l205.4282075,66.7476708-126.9614123-174.747535Z"/>
                      <circle class="st7" cx="136.8033923" cy="173.2271208" r="27"/>
                      <text class="st9" transform="translate(121.1399998 161.8476206) rotate(-54.0000007)"><tspan x="0" y="0">1</tspan></text>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path8"><tspan class="st8"><tspan x="0" y="0">點</tspan></tspan>
                        </textPath></text>
                    </g>
                    <g id="1_0">
                      <path id="path9" d="M211.2865325,89.2989811l58.7132666,180.7008542"/>
                      <path class="st12" d="M270.000029,54.000159c-44.0793352-.0362086-88.5717087,13.3601405-126.9616983,41.2521005l126.9616145,174.7476708.0000837-215.9997713Z"/>
                      <g>
                        <line class="st3" x1="154.30102" y1="97.1441816" x2="154.30102" y2="97.1441816"/>
                        <path class="st2" d="M165.096125,90.3674482c27.690918-16.234375,58.4751587-25.727417,90.539917-27.8901367"/>
                        <line class="st3" x1="262.0002998" y1="62.1451581" x2="262.0002998" y2="62.1451581"/>
                        <line class="st5" x1="262.0002998" y1="75.2332929" x2="262.0002998" y2="238.8344892"/>
                        <line class="st3" x1="262.0002998" y1="245.3785566" x2="262.0002998" y2="245.3785566"/>
                        <line class="st4" x1="254.3074287" y1="234.7904218" x2="158.1474556" y2="102.438249"/>
                      </g> -->
                      <!-- 小美大頭照 -->
                      <!-- <clipPath id="clippath">
                        <circle fill="none" cx="219.1230893" cy="113.417814" r="27"/>
                      </clipPath>
                      <circle fill="#ffe83b" cx="219.1230893" cy="113.417814" r="27"/>
                      <g clip-path="url(#clippath)">
                        <g>
                          <path fill="#00a8ca" d="M244.7953069,114.9123303c-.2267428-.0951929-.4905503-.0256446-.6416883.1687187-.1972073.2539867-.8583372.9197091-1.5523136.9606749-.3787631.0222099-.7346196-.1413846-1.0878766-.4999683-.9373292-.9520583-1.3857489-3.2179603-1.781699-5.2173287-.5952767-3.0065691-2.4869855-6.4164713-5.8612052-6.3121448.0601168.3623403.1080297.7258228.1435501,1.0898674.1324035,1.3533324.0952059,2.7099313-.1471789,4.0092446-.0261473.1398931-.0857642.2454933-.1633601.3249841.0155888.335875.004638.7006473-.0419519,1.0983003-.2383293,2.0309462-1.0860341,3.2937867-1.9642803,4.0756073-.3004683.2675207-.6032132.4790646-.8877388.6443971,2.4787527,4.3541299,5.6067873,6.3395052,9.0656787,5.7319936.3272401-.057566.6345219-.1346957.9231742-.2284845,3.7437771-1.2168119,4.3219338-5.2277632,4.3280157-5.2714426.0322655-.2442785-.1034545-.479528-.3311258-.5744192Z"/>
                          <path fill="#00a8ca" d="M231.3228316,97.4484662c-1.1954575-1.813632-2.8270574-3.3468413-4.5545122-4.6474467-1.6500952-1.2422063-3.4082112-2.2150064-5.4292919-2.6954686-1.9662252-.4672331-4.29164-.5878131-6.1008332.4550439.1239827.0427371.2479595.086246.3709811.1386626.7642484.3257739.1967814,1.4543166-.5566188,1.1789113-.3934983-.2024344-.5824627-.8207348-.1013956-1.1421879.0937157-.0626578.1902048-.1195442.2870333-.1753861-2.3969825-.8250158-4.9486972.131121-7.1390004,1.1901496-2.2365525,1.08137-4.2161599,2.6565548-5.7279025,4.6326418-1.4366697,1.8781684-2.5237648,4.0814713-3.1507304,6.3625196-.671693,2.4435314-.5665919,5.1005887.0080081,7.5518446.5649236,2.4092322,1.7444153,4.602611,4.0507112,5.7318209.045718.0222291.0904789.0383534.1345409.0499569-.2632816-.5385918-.5364913-1.0911523-.8262847-1.6655279-.0410927.0141217-.0891232.0321658-.1268441.0444221-.3487736.1133234-.5513591.1505326-.5772876.1548511-.2970549.0517361-.5795869-.1472315-.6310938-.443976-.051887-.2975192.1495616-.5814988.443976-.6310938.0043292-.0008934.1367081-.0270963.3745095-.1024379.6850119-.2174411,2.2590749-.8505304,4.2719754-2.5155764.1715408-.1418381.3300659-.2925356.4789873-.4490949.046595-.1085549.1207416-.1962922.2194389-.254281,1.8996173-2.2478841,1.7914906-5.5536306,1.7900338-5.5904977-.013537-.3011259.2206475-.5558353.5213817-.5686035.3004673-.0131947.5554205.2193708.5689198.5203807.0068308.1525317.1136779,3.0981213-1.4578831,5.557128,1.0858436-.111703,2.8973327-.5673544,4.9182529-2.1907366,1.6186443-1.2999416,3.1746677-4.3201658,2.866853-6.9332997-.3134524-2.6533903-.0800157-4.4363769.6926-5.2992336.4382671-.489116.8983024-.5107861.9862887-.5101181l-.0083255,1.0916089c-.2402742.0452205-.9390829.9413256-.633997,4.132519.7757702-.1904705,1.6270235-.0550314,2.1370642.19923.5686601.341077,1.0541856.916784,1.4468348,1.383572.663978.7892445,1.224026,1.6547311,1.8397168,2.4805808,1.2719905,1.7063849,2.9790828,3.8388175,5.2527005,4.102492.6281989.0729237.9433871-.6389962.699428-1.0336062-.088792.1461326-.1327436.2521605-.1341975.2555842-.111956.2794104-.4294874.4154319-.710012.3028114-.2794452-.112458-.4150402-.4302563-.302736-.7097798.0060972-.0151978.0440182-.104638.1127244-.2332091.2568939-.4806131.971261-1.5401174,2.3102174-1.6089521,1.0074338-.0520937,1.9862488.346011,2.6855562,1.0923385.0487711.0521617.0981222.1092676.1471859.1686483.4414628.5336924.8756674,1.3676968.9337298,2.6107072.0775959-.0794908.1372129-.185091.1633601-.3249841.2423848-1.2993133.2795824-2.6559122.1471789-4.0092446-.0355204-.3640446-.0834332-.7275272-.1435501-1.0898674-.3913137-2.3559298-1.2873724-4.652052-2.5476925-6.563816ZM219.3826777,100.604474c.0124877.0072345.0255733.0119649.0379043.0195069-.012331-.007542-.0254166-.0122725-.0379043-.0195069Z"/>
                          <path fill="#00a8ca" d="M218.4033169,131.3296142c-1.4301458-.1758793-3.2932885,2.0815825-5.7495631,5.2796-.2906605.378665-.5660023.7373394-.8182827,1.0575962l-.222383.2811578c-.2909991.3673547-.5895143.7487002-.8812121,1.1470781.3682666.1200403.7388784.2311064,1.1115507.335087,2.0982774.5857504,4.2601576.9170401,6.4380386.9859822.3754935.0119584.7512836.0153515,1.1273586.0117229-.1258457-.5192169-.2389833-1.0297312-.3223436-1.5228456-.0103454-.0606691-.0184365-.1183494-.0282074-.1784353-.7019781-.3691039-1.086306-.7526229-1.1206547-.7880416-.0783909-.0801347-.116922-.1797648-.1361344-.2823358-.0077847-.0421252-.0170434-.0832581-.0149454-.1257713l-.0000377-.0001161c.0067557-.1324375.0579194-.2632643.1600609-.3631773.2148629-.210706.5590436-.2070512.7702197.0068891.0104158.0107307.0605335.0583486.1412264.1250319-.1999368-1.7148028-.212798-3.0911938-.1525158-4.0063097-.0629623.0633158-.1364501.110034-.2163024.1359796-.1803641.0586039-.3867829.0212228-.5370642-.1158802-.2225248-.203452-.2382377-.5483972-.0349395-.7710003.0276684-.0301624.0506129-.0582767.0765781-.0877574.344633-.3914539.5451652-.722485.624501-1.0667473-.0183836-.0083984-.0362999-.0173335-.0558181-.0236951-.0445028-.01454-.0888141-.0288855-.1338691-.0316975-.0083273-.0011438-.0169333-.0011706-.0252607-.0023144"/>
                          <path fill="#00a8ca" d="M242.3972921,126.3428863c-8.0308395-1.5550439-9.2146179-1.2163488-9.5562573-.8938759-.1253983.0725672-.3192399.2085629-.5531565.4483003.1938266.1099941.3109199.3281986.272536.5599652-.0350396.2080961-.1822205.3692225-.3695484.4300891-.0795041.0258325-.1658169.0334747-.2542026.0193348-.0270595-.0042962-.1550536-.0269956-.3516724-.0843705-.5992164.9794881-1.2599166,2.6002677-1.7018409,5.2640168-.0847621.5100153-.1608615,1.0380034-.2327715,1.573356.0386253-.0398818.0621209-.0643256.0648834-.0672762.2075952-.2192516.5524528-.2285202.7715942-.0216591.2188686.2072063.2284795.5527227.0216968.7717103-.0511987.0541042-.4510792.4737746-1.066596,1.0484558-.1064093,1.0128684-.1860422,2.0520674-.2485678,3.0949468.377435-.1522774.7531846-.3113214,1.1256245-.4817367,1.6113989-.7369675,3.1738697-1.6426865,4.6626513-2.724253,3.0041484-2.1828064,5.4250887-4.8695458,7.2328941-7.8596858.1969426-.3258869.3835039-.6568697.5659887-.9897359-.130579-.0278904-.2479933-.0614698-.3832555-.0875819Z"/>
                          <path fill="#fff" d="M219.4088238,140.4278385c3.3072615-.0331681,6.6266197-.6684838,9.7845651-1.9419589.0625256-1.0428794.1421585-2.0820784.2485678-3.0949468-1.2940769,1.208085-3.5455416,3.104883-5.5463763,3.7549936-.2331734.0757626-.4628986.1344935-.6873792.1734275-1.8554261.3208222-3.2588291-.1242312-4.1499284-.5927964.0097709.0600858.017862.1177662.0282074.1784353.0833603.4931145.1964979,1.0036287.3223436,1.5228456Z"/>
                          <path fill="#fff" d="M223.0218945,138.2438305c2.5224556-.435603,6.1099465-4.0500596,6.6284736-4.5841236.0719584-.5353053.1480833-1.0633067.232718-1.5733955.4419738-2.663667,1.1026526-4.284467,1.701843-5.2639238-.9079087-.2645585-3.303696-1.283782-4.2685447-4.7896429-1.6461287,2.5259328-4.6932051,5.7402584-6.9877514,6.4858017-.2072036.0673245-.4075784.1142743-.6008406.138964-.1990656.0254546-.4064854.0424442-.6206038.0515797.7710664,1.8374262,1.0620887,2.9859326-.3840929,4.5688573-.0052856.0058081-.0121124.0092871-.0175981.014824-.0603051.9150631-.0474793,2.2914755.152532,4.0063301.4337562.3591649,1.865243,1.342459,4.163865.944729Z"/>
                          <path fill="#fff" d="M217.3323316,100.8832772c.3567216,3.0239506-1.3808092,6.3975235-3.2668326,7.9122987-1.3431292,1.0788155-2.6069743,1.695231-3.6738091,2.0418666-1.3013073.4228204-2.2999235.4437389-2.8061701.4157698-.1700831.1760508-.351725.3461909-.5472919.507967-1.3691299,1.1326255-2.5495323,1.8189005-3.4382944,2.2368978.4603728.9146676.8872929,1.789155,1.2875616,2.6133513,1.6002286,3.2928011,2.864053,5.8938039,4.8372835,7.7393534,1.8114493,1.6939452,5.6135304,3.0977415,8.4635225,3.2566242.0848419-.0134455.1683883-.0105276.2477408.0153552.410028.0126097.7976726-.0022786,1.1534096-.0477625,1.9694144-.2536956,5.6375886-3.9864923,7.2608861-6.867257,1.5874235-2.8173304,1.9021386-5.4580566,1.9052374-5.4843921.0274583-.2424833.2148737-.438315.4534084-.476818.1150353-.0212386,2.9242837-.557227,3.3684694-4.3392395.1900479-1.617109-.3039394-2.5262341-.7515156-3.0041616-.4789425-.5109964-1.1468343-.7839714-1.8324374-.7485927-.7005836.0361835-1.1318676.5735053-1.3324296.9037542.2439689.3945492-.0712891,1.1064955-.6993915,1.0335882-2.2737049-.2637276-3.980721-2.3961353-5.2527857-4.1025781-.6156287-.8257806-1.1756929-1.6913015-1.8396564-2.4806154-.3918741-.4658504-.8762631-1.0408644-1.4436436-1.382193-.5096956-.2551985-1.3629877-.3913309-2.1401822-.2004737.0142366.1493635.028026.2976955.046921.4572571Z"/>
                          <path fill="#fff" d="M218.4360418,127.6227613c-.0793525-.0258828-.1628989-.0288007-.2477408-.0153552.0821854.0045929.1672418.012848.2477408.0153552Z"/>
                          <path d="M210.3916899,110.8374426c1.0668348-.3466356,2.3306799-.9630511,3.6738091-2.0418666,1.8860234-1.5147752,3.6235543-4.8883481,3.2668326-7.9122987-.4214113-3.5693521.3356238-4.5424618.5869671-4.5898336l.008422-1.0916444c-.0880391-.0005335-.5481707.0209842-.9863696.5101196-.7726481.8629709-1.006089,2.6459269-.6926657,5.2993091.3079321,2.6130267-1.2480665,5.6333107-2.8667789,6.9332431-2.0208593,1.6233927-3.8324058,2.0790804-4.9181789,2.190827-.2486793.3891155-.5382634.7661652-.8782078,1.1179144.5062466.0279691,1.5048628.0070506,2.8061701-.4157698Z"/>
                          <path d="M215.052625,91.8782108c.7533889.2753431,1.3208299-.8532225.5565652-1.1789393-.1230628-.0524472-.2470279-.0959436-.3709569-.1386392-.0968433.0558423-.1933491.1127237-.287084.1753732-.4810399.3214119-.2920268.9396967.1014757,1.1422052Z"/>
                          <path d="M209.3526136,104.0577124c-.3007342.0127682-.5349187.2674775-.5213817.5686035.0014568.0368671.1095835,3.3426136-1.7900338,5.5904977-.0722372.0853204-.1413989.1722079-.2194389.254281-.1489214.1565593-.3074465.3072568-.4789873.4490949-2.0129005,1.665046-3.5869635,2.2981352-4.2719754,2.5155764-.2378014.0753416-.3701803.1015445-.3745095.1024379-.2944144.049595-.495863.3335746-.443976.6310938.0515069.2967445.3340389.4957121.6310938.443976.0259285-.0043185.228514-.0415277.5772876-.1548511.0377209-.0122563.0857515-.0303004.1268441-.0444221h0c.1068723-.036778.2239439-.0800779.3528022-.1305438h0c.1964806-.0769288.416169-.1708938.6595935-.2854029.8887989-.4180042,2.0691177-1.1042144,3.4382637-2.2368596.1955815-.1618396.3771782-.3319671.5473577-.5080087.3399325-.3518163.629499-.7287143.8780966-1.1179643,1.571561-2.4590067,1.4647139-5.4045963,1.4578831-5.557128-.0134993-.3010099-.2684526-.5335754-.5689198-.5203807Z"/>
                          <path d="M218.4891893,133.4287063c.0798523-.0259456.1533402-.0726638.2163024-.1359796.005406-.0054777.0122248-.0089765.0175554-.0146863,1.4462001-1.5830547,1.155285-2.731544.3841421-4.5689697-.3789107.0162269-.7818034.0040605-1.197479-.0273063.5662303,1.3169525.857809,2.037415.7110622,2.6955031-.0008359.0033512-.0017878.0067402-.0025077.0100537-.0793358.3442622-.279868.6752933-.624501,1.0667473-.0259651.0294807-.0489097.057595-.0765781.0877574-.2032982.2226032-.1875853.5675483.0349395.7710003.1502812.137103.3567.174484.5370642.1158802Z"/>
                          <path d="M230.486856,133.5707668c-.2191414-.2068611-.563999-.1975925-.7715942.0216591-.0027625.0029507-.026258.0273945-.0648834.0672762-.5186111.534084-4.1060735,4.1485358-6.628442,4.5840481-2.2986307.3978463-3.7301338-.5854801-4.1639289-.9447138-.0806928-.0666833-.1308106-.1143013-.1412264-.1250319-.2111761-.2139402-.5553568-.2175951-.7702197-.0068891-.1021415.099913-.1533052.2307398-.1600232.3632934.0050456.0419886.0098244.0835506.0149454.1257713.0192124.1025709.0577434.2022011.1361344.2823358.0343488.0354187.4186766.4189377,1.1206547.7880416.8910992.4685651,2.2945023.9136186,4.1499284.5927964.2244806-.038934.4542058-.0976648.6873792-.1734275,2.0008347-.6501106,4.2522994-2.5469086,5.5463763-3.7549936.6155169-.5746812,1.0153973-.9943515,1.066596-1.0484558.2067827-.2189876.1971718-.5645039-.0216968-.7717103Z"/>
                          <path d="M218.4360892,127.6226468c-.0805641-.0023097-.1656367-.0105969-.2477268-.0152337-2.8499848-.1589098-6.6520957-1.5626387-8.4635912-3.256563-1.9732048-1.8456635-3.2371308-4.4466049-4.8372721-7.7395189-.4002021-.8241367-.8272688-1.6985707-1.2875669-2.6132776-.2434245.1145091-.4631129.2084741-.6595935.2854029-.1288583.0504659-.2459299.0937658-.3528022.1305438.2897933.5743755.563003,1.1269361.8262847,1.6655279.1666805.340804.3334711.6823422.492272,1.0087685,1.6493092,3.3944774,2.9522203,6.0759104,5.0734228,8.0595472,1.9500985,1.8239147,5.8488284,3.3010858,8.9301942,3.5339205.4156756.0313668.8185683.0435333,1.197479.0273063.2140271-.009104.4215147-.026092.6206146-.0515182.1931517-.0247767.393611-.0716888.600786-.1390041,2.2945938-.7455587,5.3417309-3.9598922,6.9877823-6.4858321.1768861-.2715077.3427315-.5375032.484464-.7892481.1170459-.2076665.2253174-.4135085.3297587-.6181061,1.1043653-2.165158,1.5213135-4.1163278,1.6546795-4.9080097l.0037141-.0012068c.2583594-.0839461.6205347-.2290839,1.0205756-.4614626.2845256-.1653324.5872705-.3768764.8877388-.6443971.8782463-.7818206,1.725951-2.0446611,1.9642803-4.0756073.0465899-.397653.0575407-.7624254.0419519-1.0983003-.0580624-1.2430104-.492267-2.0770148-.9337298-2.6107072-.0490637-.0593807-.0984148-.1164867-.1471859-.1686483-.6993074-.7463275-1.6781225-1.1444321-2.6855562-1.0923385-1.3389565.0688347-2.0533235,1.128339-2.3102174,1.6089521-.0687063.1285711-.1066272.2180112-.1127244.2332091-.1123042.2795235.0232908.5973219.302736.7097798.2805245.1126205.598056-.023401.710012-.3028114.0014539-.0034237.0454055-.1094516.1341975-.2555842.2005264-.3302593.6318651-.867553,1.3324045-.903722.6856747-.0353171,1.3535725.2375866,1.8324494.7486004.4475978.4779339.9416296,1.3870694.7515569,3.0041663-.4441613,3.7819946-3.2534183,4.3179085-3.3685096,4.3392642-.2386024.0385181-.4259895.2342657-.4534557.4767282-.0029789.0263748-.3177588,2.6671616-1.9051999,5.4844583-1.6232739,2.8807799-5.2913672,6.6135622-7.2608655,6.8672548-.3557063.0453862-.7433679.0603503-1.1533578.0476669"/>
                          <path d="M232.2878783,125.8973107c-.0535283-.0304701-.1106404-.0565678-.1749668-.0677463-.133742-.0230131-3.2862651-.6178087-3.980051-5.1976244-.00029-.0024721-.0018973-.0042596-.0022656-.006578-.1044414.2045976-.2127129.4104396-.3297587.6181061-.1417325.2517449-.3075779.5177405-.484464.7892481.9648708,3.5058701,3.3606873,4.5251528,4.2686187,4.7896131.1966188.0573749.3246129.0800742.3516724.0843705.0883858.0141398.1746985.0064976.2542026-.0193348.187328-.0608666.3345088-.221993.3695484-.4300891.0383839-.2317666-.0787094-.4499711-.272536-.5599652Z"/>
                        </g>
                        <g>
                          <path d="M216.3159582,119.3652779c-.0543352.0176546-.112314.0268547-.1729175.0265969-.0026964-.0000205-.393566.0001133-.7264703.1082805-.2866789.0931476-.5945157-.063703-.6876633-.3503819s.063703-.5945157.3503819-.6876633c.4963154-.1612626,1.014672-.1622488,1.0721736-.1618797.3011221.0023534.5438328.2485056.5413426.5498963-.0014924.2409951-.1595063.444533-.3768471.5151512Z"/>
                          <path d="M222.599801,110.9093322c-.2181517.0708818-.4568326-.040074-.541075-.2565744-.0435506-.1064408-.4724099-1.0607111-1.721547-.854333-1.3626618.2239878-1.8154595,1.2242156-1.8343882,1.2666778-.0965904.2201162-.352925.321112-.5733911.2262043-.2200606-.0950395-.3229674-.3482875-.2297424-.5691034.0256711-.0603432.648982-1.4808861,2.4948057-1.7852043,1.5844046-.2617419,2.4441006.8002239,2.6773989,1.3982077.0878201.2247521-.0231773.477792-.2479294.5656121-.007978.0030405-.0160218.0058783-.0241316.0085133Z"/>
                          <circle cx="219.9393067" cy="111.1708301" r="1.2168402"/>
                          <path d="M217.8532942,108.3956189c-.1804415.058629-.3853597-.0063636-.4968893-.1716339-.1345227-.2001633-.081497-.4715755.1186663-.6060982l3.2996024-2.2208611c.1983335-.1332557.4709724-.0819735.6059664.1182608.1345227.2001633.081497.4715755-.1186663.6060982l-3.2996024,2.2208611c-.0345585.0233327-.0709614.0409886-.1090771.0533731Z"/>
                          <path d="M218.2456856,122.9630013c-1.641409.5333261-2.7173984-.2230069-2.7654043-.2576178-.1951711-.1412316-.2394141-.413989-.0981115-.6096314.1398783-.1945072.4110847-.2386946.6066159-.1004939.0422486.0293089.8998263.597718,2.2547881.0382178,1.423363-.5918117,1.7877801-1.636395,1.7911615-1.6466837.0773055-.2284198.3237633-.351535.5529992-.2751671.2284249.0766314.3514641.3242347.2750354.5525937-.0195888.058367-.4981513,1.4332231-2.2837935,2.1752478-.1133443.0471386-.2246203.0882256-.3332907.1235347Z"/>
                          <path d="M211.2071633,115.5199422c-.1212404.0393934-.2580524.0253438-.3715603-.0480557-.3291964-.211551-1.069426-.333258-1.6923676-.1602153-.7298173.2028375-1.2603076.5500392-1.3372404.8803249-.0553799.2351928-.2904809.3808433-.5243306.3261478-.2347266-.0546348-.3809194-.2893354-.3262846-.524062.0451538-.193541.1301187-.3652745.2423759-.5178574-.1559204.0609724-.3352444.0168029-.4569797-.1095119-.1669527-.1730392-.1631111-.4481955.0096647-.6159592.0371494-.0360543.9257071-.8844602,2.0940154-.9932966,1.5410961-.142545,2.5224583,1.0193087,2.5636764,1.0689015.1372773.1658703.1331544.4070476-.0095041.5681636-.0531725.0598648-.119694.1021005-.1914651.1254204Z"/>
                        </g>
                        <g>
                          <circle fill="#ffe83b" cx="229.5797552" cy="115.0693851" r="1.3097584"/>
                          <path d="M230.1531662,116.8339483c-.9731674.3162013-2.0219198-.218334-2.3380552-1.1912986s.2181312-2.0218539,1.1912986-2.3380552,2.0219198.218334,2.3380552,1.1912986-.2181312,2.0218539-1.1912986,2.3380552ZM229.343691,114.3426397c-.4006206.1301695-.6207042.562108-.4905347.9627286s.562108.6207042.9627286.4905347.6207042-.562108.4905347-.9627286-.562108-.6207042-.9627286-.4905347Z"/>
                        </g>
                      </g>
                      <text class="st10">
                        <textPath startOffset="30%" xlink:href="#path9"><tspan class="st8"><tspan x="0" y="0">特獎</tspan></tspan>
                        </textPath></text>
                    </g>
                  </g>
                </svg> -->
                <!-- 轉盤邊框 -->
                <!-- <img src="@/assets/img/luckywheel-outline.svg" /> -->


                <!-- transition 包裹目標元素 -->
                <!-- <transition
                  name="fade"
                  @after-leave="showStars = false"
                > -->
                <!-- 背景效果 -->
                <!-- <div v-if="showStars" class="modal-backdrop bg-black-50 z-20"></div>
                </transition> -->

                <!-- 倍數區 -->
                <!-- <svg
                  id="lucky-wheel-stars"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  viewBox="0 0 540 540"
                  width="540"
                  height="540"
                  class="z-20"
                >
                  <g>
                    <g id="1x" v-if="nextMultiplier === 1">
                      <path fill="#ffeb3b" d="M276.4824675,262.9223899c3.7832013-.0037623,7.3594959.0255125,10.9346468-.025412,1.6626316-.0236814,2.8846934.6158216,3.4101348,2.1723039.5105464,1.5123798-.1551177,2.6978671-1.4223317,3.6045306-2.5149437,1.7993834-4.971474,3.6836451-7.5322718,5.4142581-1.1687758.7898844-1.3793326,1.5852316-.9171668,2.8752007,1.0028503,2.7991221,1.8272532,5.6618338,2.8108737,8.4683136.5653785,1.6131561.4708415,3.0220371-.9553145,4.0737823-1.4458685,1.0662812-2.8162479.6313898-4.1554295-.372235-2.5276369-1.8942925-5.122787-3.6989645-7.6368957-5.6105763-.7689152-.5846516-1.3085496-.5655803-2.0581392-.0024967-2.5222491,1.8946928-5.1061689,3.707155-7.6341929,5.594353-1.3328928.9950148-2.6943999,1.4526978-4.1785783.4342433-1.5062688-1.0336104-1.5170411-2.4560817-.9748658-4.0467602.9788527-2.8718299,1.7970673-5.8017715,2.8674695-8.6375775.5135402-1.360512.1769368-2.050915-.9452464-2.8090832-2.415043-1.6316522-4.722794-3.4211835-7.1152175-5.0875701-1.42029-.9892679-2.3585938-2.2027877-1.831658-3.973199.5499074-1.8475866,2.1307558-2.1345283,3.8078535-2.1255215,2.973065.0159658,5.9472153-.0197263,8.918762.053446,1.2020644.0296022,1.8016379-.296999,2.1560427-1.5629962.8334809-2.9773291,1.9072401-5.8866478,2.8438075-8.836178.4874782-1.5352025,1.3653525-2.6011937,3.0636183-2.6457148,1.7231433-.0451786,2.6075535,1.0055386,3.1026315,2.548631,1.1113968,3.4640872,2.2643093,6.9148548,3.441468,10.496258Z"/>
                    </g>
                    <g id="2x" v-else-if="nextMultiplier === 2">
                      <path fill="#ffeb3b" d="M253.9827112,262.9223545c3.7832044-.0037623,7.3595018.0255126,10.9346556-.025412,1.662633-.0236814,2.8846958.6158221,3.4101375,2.1723057.5105468,1.512381-.1551178,2.6978693-1.4223328,3.6045335-2.5149457,1.7993848-4.971478,3.6836481-7.5322779,5.4142624-1.1687768.789885-1.3793338,1.5852328-.9171676,2.875203,1.0028511,2.7991244,1.8272547,5.6618384,2.810876,8.4683204.565379,1.6131574.4708419,3.0220396-.9553153,4.0737856-1.4458697,1.0662821-2.8162502.6313903-4.1554328-.3722353-2.5276389-1.894294-5.1227911-3.6989675-7.6369018-5.6105808-.7689158-.5846521-1.3085506-.5655807-2.0581409-.0024967-2.5222511,1.8946943-5.106173,3.707158-7.634199,5.5943575-1.3328939.9950156-2.6944021,1.452699-4.1785817.4342437-1.50627-1.0336112-1.5170423-2.4560837-.9748666-4.0467634.9788535-2.8718322,1.7970688-5.8017762,2.8674718-8.6375845.5135406-1.3605131.1769369-2.0509167-.9452471-2.8090855-2.4150449-1.6316536-4.7227978-3.4211862-7.1152233-5.0875742-1.4202911-.9892687-2.3585957-2.2027895-1.8316595-3.9732022.5499078-1.8475881,2.1307575-2.13453,3.8078565-2.1255232,2.9730674.0159658,5.9472201-.0197263,8.9187692.0534461,1.2020653.0296022,1.8016393-.2969992,2.1560444-1.5629975.8334815-2.9773315,1.9072416-5.8866525,2.8438098-8.8361851.4874786-1.5352037,1.3653536-2.6011958,3.0636207-2.6457169,1.7231447-.0451787,2.6075556,1.0055394,3.102634,2.5486331,1.1113977,3.46409,2.2643111,6.9148603,3.4414707,10.4962664Z"/>
                      <path fill="#ffeb3b" d="M298.9825275,262.9221567c3.7832044-.0037623,7.3595018.0255126,10.9346556-.025412,1.662633-.0236814,2.8846958.6158221,3.4101375,2.1723057.5105468,1.512381-.1551178,2.6978693-1.4223328,3.6045335-2.5149457,1.7993848-4.971478,3.6836481-7.5322779,5.4142624-1.1687768.789885-1.3793338,1.5852328-.9171676,2.875203,1.0028511,2.7991244,1.8272547,5.6618384,2.810876,8.4683204.565379,1.6131574.4708419,3.0220396-.9553153,4.0737856-1.4458697,1.0662821-2.8162502.6313903-4.1554328-.3722353-2.5276389-1.894294-5.1227911-3.6989675-7.6369018-5.6105808-.7689158-.5846521-1.3085506-.5655807-2.0581409-.0024967-2.5222511,1.8946943-5.106173,3.707158-7.634199,5.5943575-1.3328939.9950156-2.6944021,1.452699-4.1785817.4342437-1.50627-1.0336112-1.5170423-2.4560837-.9748666-4.0467634.9788535-2.8718322,1.7970688-5.8017762,2.8674718-8.6375845.5135406-1.3605131.1769369-2.0509167-.9452471-2.8090855-2.4150449-1.6316536-4.7227978-3.4211862-7.1152233-5.0875742-1.4202911-.9892687-2.3585957-2.2027895-1.8316595-3.9732022.5499078-1.8475881,2.1307575-2.13453,3.8078565-2.1255232,2.9730674.0159658,5.9472201-.0197263,8.9187692.0534461,1.2020653.0296022,1.8016393-.2969992,2.1560444-1.5629975.8334815-2.9773315,1.9072416-5.8866525,2.8438098-8.8361851.4874786-1.5352037,1.3653536-2.6011958,3.0636207-2.6457169,1.7231447-.0451787,2.6075556,1.0055394,3.102634,2.5486331,1.1113977,3.46409,2.2643111,6.9148603,3.4414707,10.4962664Z"/>
                    </g>
                    <g id="3x" v-else-if="nextMultiplier === 3">
                      <path fill="#ffeb3b" d="M274.3217428,265.2815735c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M244.3218894,265.2815735c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M304.3215961,265.2814416c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                    </g>
                    <g id="4x" v-else-if="nextMultiplier === 4">
                      <path fill="#ffeb3b" d="M289.3216694,251.8654876c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,251.8654876c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,278.6975275c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M289.3216694,278.6973956c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                    </g>
                    <g id="5x" v-else-if="nextMultiplier === 5">
                      <path fill="#ffeb3b" d="M289.3216694,251.8654876c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,251.8654876c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M274.3217428,278.6975275c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M244.3218894,278.6975275c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M304.3215961,278.6973956c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                    </g>
                    <g id="6x" v-else-if="nextMultiplier === 6">
                      <path fill="#ffeb3b" d="M289.3216694,238.4494677c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,238.4494677c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M274.3217428,265.2815075c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M244.3218894,265.2815075c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M274.3217428,292.1135474c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M304.3215961,265.2813756c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                    </g>
                    <g id="7x" v-else-if="nextMultiplier === 7">
                      <path fill="#ffeb3b" d="M289.3216694,238.4494677c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M289.3216694,292.1134155c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,238.4494677c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M274.3217428,265.2815075c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M244.3218894,265.2815075c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M259.3218161,292.1135474c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                      <path fill="#ffeb3b" d="M304.3215961,265.2813756c2.5221342-.0025082,4.9063306.0170084,7.2897645-.0169413,1.1084211-.0157876,1.923129.4105477,2.2734232,1.4482026.3403643,1.0082532-.1034118,1.7985781-.9482211,2.4030204-1.6766292,1.1995889-3.314316,2.4557634-5.0215146,3.6095054-.7791839.5265896-.9195551,1.056821-.6114446,1.9168005.6685669,1.8660814,1.2181688,3.7745559,1.8739158,5.6455424.376919,1.0754374.3138943,2.0146914-.6368763,2.7158549-.9639123.7108542-1.8774986.4209265-2.7702863-.2481567-1.6850913-1.2628617-3.4151913-2.4659763-5.0912638-3.7403842-.5126101-.3897678-.8723664-.3770535-1.3720928-.0016645-1.6814994,1.2631285-3.4041126,2.4714367-5.0894619,3.7295687-.8885952.6633432-1.7962666.9684652-2.7857189.2894955-1.0041792-.6890736-1.0113607-1.6373878-.6499105-2.6978401.6525684-1.9145532,1.1980449-3.8678477,1.9116463-5.758385.3423601-.907008.1179578-1.3672767-.6301643-1.8727222-1.6100287-1.0877682-3.1485293-2.280789-4.7434784-3.3917134-.94686-.659512-1.5723959-1.4685251-1.2211054-2.6487993.3666049-1.2317244,1.4205039-1.4230188,2.538569-1.4170143,1.9820433.0106438,3.9648102-.0131509,5.9458413.0356307.8013762.0197348,1.2010919-.1979993,1.4373618-1.0419975.5556539-1.9848861,1.2714934-3.9244318,1.8958717-5.8907853.3249855-1.0234683.910235-1.7341292,2.0424122-1.7638099,1.1487622-.0301191,1.738369.6703591,2.068421,1.6990873.7409312,2.3093915,1.5095395,4.6099032,2.294312,6.9975053Z"/>
                    </g>
                  </g>
                </svg> -->
                <!-- transition 包裹目標元素 -->
                <!-- <transition
                  name="fade"
                  @after-leave="showStars = false"
                > -->
                  <!-- 發光效果 -->
                  <!-- <img v-if="showStars" class="z-20" src="@/assets/img/luckywheel-light.svg" />
                </transition> -->

                <!-- transition 包裹目標元素 -->
                <!-- <transition
                  name="fade"
                  @after-leave="showStars = false"
                > -->
                <!-- 提示文字 -->
                <!-- <div v-if="showStars" class="absoluteFlexCenter text-center z-20" style="top: 35%;">
                  <h6 class="fs-5.5 text-white">
                    恭喜您!!<br>
                    抽獎次數已達 {{gameStats.totalPlays}} 次，<br>
                    獲取點數升級為 <b class="text-tertiary fs-4">{{nextMultiplier}}</b> 倍！
                  </h6>
                </div>
                </transition>



              </div> -->
              <!-- <div class="w-100 flex-column flexCenter">
                <button 
                    @click="playGame"
                    :disabled="isLoading || isSpinning || !gameStats.canPlay"
                    class="btn btn-tertiary warning-mix-black-50 w-100 h-48 mb-3"
                >
                <div v-if="isSpinning || (!isLoading && !nextPlayTime && 
                        !(gameStats.remainingPlays <= 0) && 
                        !gameStats.canPlay)"
                  class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <b>
                    <span v-if="isLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span v-if="isLoading" role="status">&nbsp;遊戲載入中...</span>
                    <span v-else-if="isSpinning"></span>
                    <span v-else-if="nextPlayTime">{{ nextPlayTime }}後可再次抽獎</span>
                    <span v-else-if="gameStats.remainingPlays <= 0">今日抽獎次數已用完</span>
                    <span v-else-if="gameStats.canPlay">&emsp;開始抽獎</span>
                    <span v-else></span>
                </b>
                    <img 
                        v-if="gameStats.canPlay && !isLoading && !isSpinning"
                        class="clickIcon" 
                        src="@/assets/img/click.svg" 
                        width="30" 
                        height="30" 
                    />
                </button>
                <button
                  v-if="gameStats.totalPoints > 0"
                  class="btn btn-tertiary warning-mix-black-50 w-100 h-48 mb-3"
                  @click="handleShare"
                  :disabled="isSharing || isLoading || isSpinning"
                  >
                  <b>{{ isSharing ? '分享中...' : '立即分享' }}</b>
                </button>
                <p v-if="gameStats.totalPoints > 0" class="text-center text-white">
                  <b>分享給朋友當日達到10人參加，可再獲得1次抽獎機會唷！</b>
                </p>
              </div> -->

            </div>
          </div>

          <!-- user data -->
          <div class="lucky-wheel-container bg-primary-mix-black-30">
            <!-- <header class="text-tertiary fs-5.5 flexCenter">
              <b>我的記錄</b>
            </header>
            <div class="d-inline-flex gap-2 text-center warning-mix-black-50 small lh-1">
              <div class="p-3 rounded bg-tertiary">
                <b>今日已分享<br>
                  <span class="fs-4 d-inline-block mx-1 mt-1">
                    <animated-number :value="gameStats.sharedPlayers" />
                  </span>人
                </b>
              </div>
              <div class="p-3 rounded bg-tertiary">
                <b>今日可抽獎<br>剩餘
                  <span class="fs-4 d-inline-block mx-1 mt-1">
                    <animated-number :value="gameStats.remainingPlays" />
                  </span>次
                </b>
              </div>
              <div class="p-3 rounded bg-tertiary">
                <b>已獲得點數<br>
                  <span class="fs-4 d-inline-block mx-1 mt-1">
                    <animated-number :value="gameStats.totalPoints" />
                  </span>點
                </b>
              </div>
            </div> -->

            <header class="text-tertiary fs-5.5 flexCenter">
              <b>點數排行榜</b>
            </header>
            <!-- <p class="text-white small">還沒有任何資料喔！</p> -->
            <div class="table-outer rounded-3 p-2">
              <div class="flex-table ranking mx-auto">
                <div>
                  <div class="th">排行</div>
                  <div class="th">姓名</div>
                  <div class="th">獲得點數</div>
                </div>
                <template v-for="entry in leaderboard">
                  <div v-if="entry.rank <= 10" :key="entry.user_id"
                      :class="{ 'highlight': entry.is_self,
                                'bg-danger-mix-white-60': entry.rank === 1,
                                'bg-warning-mix-white-50': entry.rank === 2,
                                'bg-tertiary-mix-white-50': entry.rank === 3
                              }">
                    <div class="td text-nowrap">
                      <span v-if="entry.rank === 1" class="fs-2 text-shadow">🥇</span>
                      <span v-else-if="entry.rank === 2" class="fs-3">🥈</span>
                      <span v-else-if="entry.rank === 3" class="fs-3">🥉</span>
                      <b v-else>{{ entry.rank }}</b>
                    </div>
                    <div class="td">{{ entry.display_name }}</div>
                    <div class="td">{{ entry.total_points }}點</div>
                  </div>
                </template>
                <div v-if="leaderboard.some(e => e.rank > 11)" class="separator-row">
                  <div class="td text-center">⋮</div>
                  <div class="td text-center">⋮</div>
                  <div class="td text-center">⋮</div>
                </div>
                <template v-for="entry in leaderboard">
                  <div v-if="entry.rank > 11" :key="entry.user_id"
                      :class="{ 'highlight': entry.is_self }">
                    <div class="td text-nowrap">
                      <b>{{ entry.rank }}</b>
                    </div>
                    <div class="td">{{ entry.display_name }}</div>
                    <div class="td">{{ entry.total_points }}點</div>
                  </div>
                </template>
              </div>
            </div>

            <header class="text-tertiary fs-5.5 flexCenter">
              <b>得獎名單</b>
            </header>
            <div v-if="winners && winners.length > 0" class="table-outer rounded-3 p-2 mb-3">
              <div class="flex-table winner mx-auto">
                <div>
                  <div class="th">時間</div>
                  <div class="th">姓名</div>
                  <div class="th">獲得獎項</div>
                </div>
                <div v-for="record in winners" :key="record.redemption_id">
                  <div class="td text-nowrap">{{ formatDate(record.redeemed_at) }}</div>
                  <div class="td">{{ record.masked_name }}</div>
                  <div class="td">{{ record.item_name }}</div>
                </div>
              </div>
            </div>
            <p v-else class="text-white small">還沒有任何資料喔！</p>

          </div>

          <!-- rules -->
          <div class="lucky-wheel-container">
            <header class="text-tertiary fs-5.5 flexCenter">
              <b>活動獎項</b>
            </header>
            <div class="carousel-outer bg-white p-2" v-if="redeemableItems.length > 0">
              <div id="carouselCaptions" class="carousel slide">
                <div class="carousel-indicators">
                  <button 
                    v-for="(item, index) in redeemableItems" 
                    :key="index"
                    type="button" 
                    data-bs-target="#carouselCaptions" 
                    :data-bs-slide-to="index" 
                    :class="{ active: index === 0 }" 
                    :aria-current="index === 0" 
                    :aria-label="'Slide ' + (index + 1)">
                  </button>
                </div>
                <div class="carousel-inner rounded-3">
                  <div 
                    v-for="(item, index) in redeemableItems" 
                    @click="handleUrlClick(item.intro_url)"
                    :key="index"
                    class="carousel-item"
                    :class="{ active: index === 0 }">
                    <img :src="item.image_url" class="d-block w-100" :alt="item.name">
                    <div class="bg-gradient-black"></div>
                    <div class="carousel-caption">
                      <h5 class="fs-6 m-0">{{ item.name }}</h5>
                    </div>
                    <label class="text-center d-block">
                      市價: <b class="text-danger">{{ item.price }}</b> 元<br>
                      需要點數: <b>{{ item.points_required }}</b> 點
                    </label>
                  </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselCaptions" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselCaptions" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <!-- <button
                class="btn btn-tertiary warning-mix-black-50 w-100 h-48 mb-3"
                :disabled="isSharing || isLoading || isSpinning"
                @click="showRewardPanel"
                >
                🎁 <b>我要兌獎</b>
              </button> -->
            <header class="text-tertiary fs-5.5 flexCenter">
              <b>活動詳情</b>
            </header>
            <div class="card border-0 rounded-3">
              <div class="card-body">
                <h6 class="text-center mt-2">🎊 <b>小美幸運星輪盤活動</b> 🎊</h6>
                <p>活動期間：2025/1/1 - 2025/2/28</p>
                <h6>📌 <b>遊戲規則</b></h6>
                <ul>
                  <li>每日基本可玩 2 次</li>
                  <li>每日清晨 5:00 重置遊戲次數</li>
                  <li>兩次遊戲需間隔 8 小時</li>
                </ul>
                <h6>⏰ <b>遊戲時間說明</b></h6>
                <ul>
                  <li>每日清晨 5:00 後即可開始遊玩</li>
                  <li>第一次遊玩後，需等待 8 小時才能進行第二次</li>
                  <li>例如：早上 6:00 玩第一次，需等到下午 14:00 後才能玩第二次</li>
                </ul>
                <h6>🎁 <b>額外獎勵機會</b></h6>
                <ul>
                  <li>成功邀請 10 位不重複好友參與遊戲</li>
                  <li>達成後即可獲得 Bonus 遊戲機會</li>
                  <li>Bonus 次數不受間隔時間限制</li>
                  <li>每日可使用 1 次 Bonus 機會</li>
                </ul>
                <h6>💫 <b>倍數機制</b></h6>
                <ul>
                  <li>初始倍數為 1 倍，每累積 10 次遊玩獲取點數提升 1 倍</li>
                  <li>倍數最高可達 7 倍</li>
                  <li>例如：遊玩累積 25 次時倍數為 3 倍，若轉到 3 點，則獲得 3 點 × 3 倍 = 9 點</li>
                </ul>
                <h6>💡 <b>溫馨提醒</b></h6>
                <ul>
                  <li>每日清晨 5:00 將重置基本遊戲次數、Bonus及分享統計</li>
                  <li>把握機會邀請好友一起同樂！</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- about xiaomei  -->
          <div class="lucky-wheel-container bg-primary-mix-black-30">
            <!-- <header class="text-tertiary fs-5.5">
              <b>關於小美祕書</b>
            </header> -->
            <div class="flexCenter flex-column gap-2">
              <img src="https://profile.line-scdn.net/0hDmzDDKNyG0JHPQnXwt9kFXt4FS8wEx0KPw8EJDZpESU5DA4cL1NUIGZtRSFiXwxGfQhRIWs9FnZt"
              class="rounded-pill" width="58" height="58" alt="小美祕書">
            <!--  <small class="text-white text-justify">
                小美祕書是基於 AI 技術的電商助手，透過 LINE 提供商品管理與行銷服務。一站式功能包含商品搜尋比價、智能文案生成、訂單管理等。我們與品牌商合作，定期推送最新商品情報與優惠碼，輕鬆提升競爭力。立即加入，開啟智慧電商新時代！
              </small> -->
              <small class="text-white-50">Copyright © 2025 Camangi Corp. All rights reserved.</small>
            </div>
            <!-- <a role="button" class="btn btn-success btn-line text-white w-100 h-48 mb-3 flexCenter"
              href="https://lin.ee/5DlVwME">
              <img src="@/assets/img/line_132.png" width="44px" height="44px" />
              <b>立即加入</b>
            </a> -->
          </div>
        </div>
        
        <!-- 兌獎畫面 -->
        <reward-redeem v-else
          :redeemable-items="redeemableItems"
          :my-redemptions="myRedemptions"
          :user-points="gameStats.totalPoints"
          :user-available-points="gameStats.availablePoints"
          :game-token="gameToken"
          @close="handleClose"
          class="mt-header"
        />
      </div>



    </div>
  </div>

  </template>
  
  <script>
  import liff from '@line/liff';
  import QRCode from 'qrcode'
  import { mapGetters } from 'vuex';
  import { showModal, cleanupModals } from '@/utils/modal'
  // import AnimatedNumber from '@/components/AnimatedNumber.vue'
  import RewardRedeem from '@/components/RewardRedeem.vue'
  import axios from 'axios'

  const eventId = process.env.VUE_APP_LUCKY_WHEEL_EVENT_ID;
  const specialPrizeId = process.env.VUE_APP_LUCKY_WHEEL_SPECIAL_PRIZE_ID;

  export default {
    name: 'LuckyWheelView',
    components: {
      // AnimatedNumber,
      RewardRedeem
    },
    data() {
      return {
        rotation: 0,
        isSpinning: false,
        currentPrize: null,
        isLoading: true,
        isInitialized: false,
        gameToken: null,
        prizes: [],
        gameStats: {
            sharedPlayers: 0,
            remainingPlays: 0,
            bonusPlays: 0,
            totalPoints: 0,
            availablePoints: 0,
            canPlay: false,
            current_multiplier: undefined,
            totalPlays: undefined
        },
        multiplier_threshold: 0,
        max_multiplier: 0,
        nextPlayTime: null,
        countdownTimer: null,
        isSharing: false,
        showStars: false,
        showQRCode: false,
        qrCodeDataUrl: '',
        leaderboard: [],
        showReward: false,
        winners: [],
        redeemableItems: [],
        myRedemptions: []
      }
    },
    computed: {
      ...mapGetters(['userId', 'token', 'name']),
      nextMultiplier() {
        if (!this.gameStats || this.gameStats.totalPlays === undefined) {
          return null;
        }

        const nextTotalPlays = this.gameStats.totalPlays + 1;
        const calculatedMultiplier = Math.min(
          Math.floor((nextTotalPlays - 1) / this.multiplier_threshold) + 1,
          this.max_multiplier
        );

        // Ensure the multiplier starts from 1 and increases up to max_multiplier
        return calculatedMultiplier;
      }
    },
    beforeUnmount() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
    },
    onUnmounted() {
      cleanupModals()
    },
    async mounted() {
      try {
        // Wait for LINE auth to complete
        await this.checkLineApp()
        
        if (!this.userId) {
          this.$router.push('/me?page=luckywheel')
          return
        }

        // Initialize in correct order
        await this.initializeGame()
        await this.fetchRedeemableItems()
        
      } catch (error) {
        console.error('Initialization error:', error)
        // Add proper error handling
      }
    },
    methods: {
      async waitForToken(maxAttempts = 5) {
        let attempts = 0;
        while (!this.token && attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, 500));
          showModal('trying to get token', {autoCloseSeconds: 1});
          attempts++;
        }
        return !!this.token;
      },
      async initializeGame(maxRetries = 3) {
        let attempt = 0;
        
        const tryInitialize = async () => {
          try {
            const tokenReady = await this.waitForToken();
            if (!tokenReady) {
              throw new Error('Token not available after maximum attempts');
            }

            const response = await axios.post(
              `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/auth/line`,
              { id_token: this.token },
              {
                headers: {
                  "ngrok-skip-browser-warning": "69420"
                },
                timeout: 30000 // 30 second timeout
              }
            );

            const data = response.data;
            if (data.token) {
              this.gameToken = data.token;
              this.isInitialized = true;
              await this.fetchPrizes();
              await this.checkGameStatus();
              await this.fetchMyRedemptions();
            }
            
            return true; // Success
            
          } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            return false; // Retry needed
          }
        };

        while (attempt < maxRetries) {
          const success = await tryInitialize();
          if (success) {
            this.isLoading = false;
            return; // Exit if successful
          }
          
          attempt++;
          if (attempt < maxRetries) {
            // Exponential backoff: 1s, 2s, 4s...
            await new Promise(resolve => 
              setTimeout(resolve, Math.pow(2, attempt) * 1000)
            );
          }
        }

        // All retries failed
        showModal('遊戲載入失敗，請稍後再試', { persistent: true });
        this.isLoading = false;
      },
      async fetchPrizes() {
        try {
            const response = await axios.get(
                `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/admin/events/${eventId}`,
                {
                    headers: {
                        'Authorization': `Bearer ${this.gameToken}`,
                        "ngrok-skip-browser-warning": "69420"
                    }
                }
            );
            const data = response.data;
            this.prizes = data.prizes.map(prize => ({
                name: prize.name,
                probability: prize.probability,
                prize_id: prize.prize_id,
                is_point: prize.is_point
            }));
            this.multiplier_threshold = data.multiplier_threshold;
            this.max_multiplier = data.max_multiplier;
        } catch (error) {
            console.error('Failed to fetch prizes:', error);
        }
      },
      async fetchRedeemableItems() {
        const response = await axios.get(
            `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/admin/events/${eventId}/redeemable-items`,
            {
                headers: {
                    'Authorization': `Bearer ${this.gameToken}`,
                    "ngrok-skip-browser-warning": "69420"
                }
            }
        );
        const data = response.data;
        this.redeemableItems = data
      },
      async fetchLeaderboard() {
        const response = await axios.get(
          `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/game/leaderboard/${eventId}`,
          {
            headers: {
              'Authorization': `Bearer ${this.gameToken}`,
              "ngrok-skip-browser-warning": "69420"
            }
          }
        );

        if (response.status === 200) {
          this.leaderboard = response.data;
        }
      },

      async checkGameStatus() {
        try {
          const response = await axios.get(
              `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/game/status/${eventId}?display_name=${encodeURIComponent(this.name)}`,
              {
                  headers: {
                      'Authorization': `Bearer ${this.gameToken}`,
                      "ngrok-skip-browser-warning": "69420"
                  }
              }
          );

          const data = response.data;
          console.log('Game status data:', data);
          // 先判斷是否需要計時
          if (data.next_play_time && data.remaining_plays > 0 && !data.can_play) {
              this.startCountdown(new Date(data.next_play_time).getTime());
          } else if (this.countdownTimer) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
              this.nextPlayTime = null;
          }

          // 取得排行榜
          await this.fetchLeaderboard();
          // 取得得獎者清單
          await this.fetchWinners();

          // 確保計時狀態設置完才更新遊戲狀態
          const isProcessing = this.isSpinning || this.countdownTimer;  // 增加檢查是否正在轉動
          this.gameStats = {
              sharedPlayers: data.shared_friends_count || 0,
              remainingPlays: data.remaining_plays,
              bonusPlays: data.bonus_plays || 0,
              totalPoints: data.total_points,
              availablePoints: data.available_points,
              canPlay: data.can_play && !isProcessing, // 使用緩衝狀態
              current_multiplier: data.current_multiplier || 1,
              totalPlays: data.total_plays || 0
          };
          return true;
          
        } catch (error) {
          console.error('Failed to check game status:', error)
          if (error.response?.status === 404) {
              //showModal('活動尚未開始！', { persistent: true });
              showModal('目前沒有活動喔！');
              this.isInitialized = false;
              return false;
          }
          showModal('系統維護中，請稍後再試！', { persistent: true});
          this.isInitialized = false;
          return false;
        }
      },

      async handleMultiplierEffect(oldMultiplier, newMultiplier) {
        if (
          newMultiplier !== oldMultiplier &&
          oldMultiplier !== undefined && 
          oldMultiplier !== null && 
          oldMultiplier !== 0 &&
          newMultiplier > 1 &&
          newMultiplier > oldMultiplier
        ) {
          this.showStars = true;
          await new Promise(resolve => setTimeout(resolve, 5000));
          this.showStars = false;
        }
      },

      async playGame() {
          if (!this.gameStats.canPlay) {
              showModal('今日抽獎次數已用完', { persistent: true});
              return;
          }

          try {
              const prize = await this.spin();
              
              // Get URL parameters
              const urlParams = new URLSearchParams(window.location.search);
              const shareId = urlParams.get('sid');

              // Determine which API endpoint to call
              const endpoint = shareId 
                  ? `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/game/play/${eventId}/shared`
                  : `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/game/play/${eventId}`;

              // Prepare query parameters
              const queryParams = new URLSearchParams({
                  ...(shareId && { share_id: shareId }),
                  prize_id: prize.prize_id
              }).toString();

              const response = await axios.post(
                `${endpoint}?${queryParams}`,
                null,  // empty body since data is in query params
                {
                    headers: {
                        'Authorization': `Bearer ${this.gameToken}`,
                        "ngrok-skip-browser-warning": "69420",
                        'Content-Type': 'application/json'
                    }
                }
            );

            const result = response.data;
            console.log('Game result:', result);
              
            await this.checkGameStatus();

            const oldMultiplier = this.gameStats.current_multiplier;
            const newMultiplier = this.nextMultiplier;
            
            let prizeText = this.currentPrize.item_id === specialPrizeId 
            ? `恭喜獲得 <b class="text-danger">${this.currentPrize.name}</b>！<br>請至兌獎頁面作兌換登記並填寫您的聯絡資訊！`
            : this.gameStats.current_multiplier >= 2 && this.currentPrize.is_point
              ? `恭喜獲得 <b class="text-danger">${this.currentPrize.name} &#215; ${this.gameStats.current_multiplier}倍</b>！` 
              : `恭喜獲得 <b class="text-danger">${this.currentPrize.name}</b>！`;

            if (this.currentPrize.name == "1點" && this.gameStats.current_multiplier < 2) {
              prizeText += '<br><br>' + '加油！堅持下去💪';
              await showModal(prizeText);
            } else {
              await showModal(prizeText);
            }
            await this.handleMultiplierEffect(oldMultiplier, newMultiplier);
          } catch (error) {
              console.error('Game play failed:', error);
              showModal('系統維護中，請稍後再試！', { persistent: true});
          }
      },
      startCountdown(nextPlayTimestamp) {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
        
        this.countdownTimer = setInterval(() => {
            const now = new Date().getTime();
            const distance = nextPlayTimestamp - now;
            
            if (distance < 0) {
                clearInterval(this.countdownTimer);
                this.checkGameStatus();
                return;
            }
            
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            this.nextPlayTime = hours > 0 ? 
                `${hours}小時${minutes}分${seconds}秒` : 
                `${minutes}分${seconds}秒`;
            }, 1000);
      },
      getPath(angle) {
        const radius = 150;
        const endAngle = angle;
        const largeArcFlag = endAngle > 180 ? 1 : 0;
        const x = radius * Math.cos(Math.PI * endAngle / 180);
        const y = radius * Math.sin(Math.PI * endAngle / 180);
        return `M0,0 L${radius},0 A${radius},${radius} 0 ${largeArcFlag},1 ${x},${y} Z`;
      },
      getRandomPrize() {
        /* return {
          prize_id: '928ef2dd-89c0-42f7-843c-713a122d4158',
          name: '二仁堂家庭號',
          is_point: false,
          is_play_again: false,
          points: 0,
          probability: 0.1,
          order: 10
        }; */
        
        // Original code commented out for testing
        
        const total = this.prizes.reduce((sum, prize) => sum + prize.probability, 0);
        let random = Math.random() * total;
        
        for (const prize of this.prizes) {
          if (random < prize.probability) {
            return prize;
          }
          random -= prize.probability;
        }
      },
      async spin() {
        return new Promise((resolve) => {
          if (this.isSpinning || !this.userId) return;

          this.isSpinning = true;
          this.currentPrize = null;

          const selectedPrize = this.getRandomPrize();
          const prizeIndex = this.prizes.indexOf(selectedPrize);
          const sectionAngle = 360 / this.prizes.length;
          const extraSpins = 5;

          const sectorStartAngle = -prizeIndex * sectionAngle;
          const sectorEndAngle = sectorStartAngle - sectionAngle;
          const deltaAngle = sectorStartAngle - sectorEndAngle;
          const randomOffset = sectorStartAngle - Math.random() * deltaAngle;
          const currentRotationIn360 = this.rotation % 360;
          const rotationIncrement = 360 * extraSpins + (randomOffset - currentRotationIn360);

          this.rotation += rotationIncrement;

          // Keep isSpinning true until next play time is set
          setTimeout(async () => {
            this.currentPrize = selectedPrize;
            await this.checkGameStatus(); // Wait for stats update
            this.isSpinning = false;  // Only set false after stats update
            resolve(selectedPrize);
          }, 5000);
        });
      },
      async handleShare() {
        if (!liff.isApiAvailable('shareTargetPicker')) {
          showModal('分享功能目前尚未開放喔！');
          return
        }

        this.isSharing = true
        
        try {
          const response = await axios.post(
              `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/game/share/${eventId}`,
              {},  // empty object as body
              {
                  headers: {
                      'Authorization': `Bearer ${this.gameToken}`,
                      "ngrok-skip-browser-warning": "69420"
                  }
              }
          );

          const res = response.data;

          if (!res.success) {
            showModal('分享失敗，請稍後再試！');
            return;
          }

          const liff_app_uri = `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}?page=luckywheel&sid=${res.share_id}`;

          const result = await liff.shareTargetPicker([
            {
              type: "flex",
              altText: "小美幸運星轉輪抽獎",
              contents: {
                type: "bubble",
                hero: {
                  type: "image",
                  url: "https://storage.googleapis.com/xiaomei-ad-content/game_service/luckywheel-15.png",
                  size: "full",
                  aspectRatio: "20:13",
                  aspectMode: "cover",
                  action: {
                    type: "uri",
                    uri: "https://line.me/"
                  }
                },
                body: {
                  type: "box",
                  layout: "vertical",
                  contents: [
                    {
                      type: "text",
                      text: "2025 小美幸運星輪盤",
                      weight: "bold",
                      size: "lg",
                      align: "center"
                    },
                    {
                      type: "box",
                      layout: "vertical",
                      margin: "lg",
                      spacing: "sm",
                      contents: [
                        {
                          type: "text",
                          text: "3月1日前，每天可進入轉盤遊戲擁有2次抽獎機會，最高可獲得特獎(價值$2580元)！分享好友當日滿10位以上參加，還可加碼1次抽獎機會！",
                          size: "xs",
                          wrap: true,
                          color: "#666666"
                        },
                        {
                          type: "text",
                          text: "※參與遊戲即表示您同意相關活動規則。",
                          size: "xxs",
                          color: "#999999",
                          wrap: true
                        }
                      ]
                    }
                  ]
                },
                footer: {
                  type: "box",
                  layout: "vertical",
                  contents: [
                    {
                      type: "button",
                      style: "primary",
                      height: "sm",
                      action: {
                        type: "uri",
                        label: "立即參加",
                        uri: liff_app_uri
                      },
                      color: "#00a8ca"
                    },
                    {
                      type: "box",
                      layout: "vertical",
                      contents: []
                    }
                  ],
                  paddingAll: "xl"
                }
              }
            },
            {
              type: "text",
              text: `🎊 小美幸運星輪盤活動 🎊

活動期間：2025/1/1 - 2025/2/28


📌 遊戲規則
每日基本可玩 2 次
每日清晨 5:00 重置遊戲次數
兩次遊戲需間隔 8 小時

⏰ 遊戲時間說明
每日清晨 5:00 後即可開始遊玩
第一次遊玩後，需等待 8 小時才能進行第二次
例如：早上 6:00 玩第一次，需等到下午 14:00 後才能玩第二次

🎁 額外獎勵機會
成功邀請 10 位不重複好友參與遊戲
達成後即可獲得 Bonus 遊戲機會
Bonus 次數不受間隔時間限制
每日可使用 1 次 Bonus 機會

💫 倍數機制
初始倍數為 1 倍，每累積 10 次遊玩獲取點數提升 1 倍
倍數最高可達 7 倍
例如：遊玩累積 25 次時倍數為 3 倍，若轉到 3 點，則獲得 3 點 × 3 倍 = 9 點

💡 溫馨提醒
每日清晨 5:00 將重置基本遊戲次數、Bonus及分享統計
把握機會邀請好友一起同樂！`
            },
            {
              type: "text",
              text: "大家可以抽點數累積換獎品喔！"
            }
          ]);

          if (result) {
            await this.checkGameStatus()
          }
        } catch (error) {
          console.error('Share failed:', error)
        } finally {
          this.isSharing = false
        }
      },
      async checkLineApp() {
        if (!liff.isInClient()) {
          // Not accessing from LINE app
          this.showQRCode = true
          await this.generateQRCode()
        } else {
          // Accessing from LINE app
          this.showQRCode = false
        }
      },
      async generateQRCode() {
        // Get the current URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const sid = urlParams.get('sid');

        // Construct the URL based on whether userId is available
        let qrCodeUrl = `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}?page=luckywheel`
        
        if (sid) {
          qrCodeUrl += `&sid=${sid}`;
        }

        // Generate QR code data URL
        try {
          this.qrCodeDataUrl = await QRCode.toDataURL(qrCodeUrl, {
            width: 256,  // 設定寬度(像素)
            height: 256, // 設定高度(像素)
            margin: 2,   // 可選：設定邊距
            color: {     // 可選：自訂顏色
              dark: '#000000',  // QR碼顏色
              light: '#ffffff'  // 背景顏色
            }
          })
        } catch (err) {
          console.error('Failed to generate QR code', err)
        }
      },

      formatDate(datetime) {
        const date = new Date(datetime)
        return `${date.getFullYear()}/${String(date.getMonth()+1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`
      },
      async fetchWinners() {
        const response = await axios.get(
            `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/admin/events/${eventId}/redemptions`,
            {
                headers: {
                    'Authorization': `Bearer ${this.gameToken}`,
                    "ngrok-skip-browser-warning": "69420"
                }
            }
        );

        this.winners = response.data;
      },

      handleClose() {
        this.showReward = false // 關閉兌獎面板
        if (this.$refs.luckyWheel) {
          this.$refs.luckyWheel.scrollIntoView({ 
            block: 'start',
            behavior: 'auto'  // This ensures instant scrolling
          });
        }
      },
      showRewardPanel() {
        this.showReward = true // 顯示兌獎面板
        if (this.$refs.luckyWheel) {
          this.$refs.luckyWheel.scrollIntoView({ 
            block: 'start',
            behavior: 'auto'  // This ensures instant scrolling
          });
        }
      },
      handleUrlClick(targetUrl) {
        if (liff && liff.isInClient()) {
          liff.openWindow({ url: targetUrl, external: false });
        } else {
          window.location.href = targetUrl;
        }
      },
      async fetchMyRedemptions() {

        try {
          const response = await axios.get(
            `${process.env.VUE_APP_GAME_SERVICE_URL}/api/v1/redemption/history/${eventId}`,
            {
                headers: {
                    'Authorization': `Bearer ${this.gameToken}`,
                    "ngrok-skip-browser-warning": "69420"
                }
            }
          )

          this.myRedemptions = response.data
        } catch (error) {
          console.error('Failed to fetch redemptions:', error)
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  $spacer: 0.875rem;
  $headerHeight: calc($spacer * 3);
  
  #liff {
    overflow-y: auto;
    width: 100%;
    max-width: 640px;
  
    &::-webkit-scrollbar {
      width: 0;
    }
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
  
    > * {
      width: 100%;
    }
  }

  .bg-gradient {
    background: linear-gradient(#00a8ca 60%, #38e4e3 100%)!important;
  }
  .bg-gradient-black {
    background: linear-gradient(rgba($color: #000, $alpha: 0) 50%, rgba($color: #000, $alpha: .5) 95%)!important;
  }
  
  .h-header {
    height: $headerHeight;
  }
  
  .mt-header {
    margin-top: $headerHeight;
  }
  
  @mixin container-styles {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px;

    .btn {
      max-width: 300px;
      
      .clickIcon {
        margin: -4px 0 0;
        transition: .2s all ease-out;
      }
      
      &:hover {
        .clickIcon {
          transform: scale(130%);
        }
      }
      
      &.btn-line {
        max-width: 240px;
        background-color: #06c755;
        border-color: #06c755;
      }
    }

    header {
      margin: 10px 0 -10px;
    }

    //flex-table
    .flex-table {
      display: table;
      width: 300px;
      > * {
        display: table-row;
        &:nth-child(even) {
          background-color: rgba($color: #fff, $alpha: .3);
        }
        &:last-child >* {border-bottom: 0!important;}
      }
      .th,.td {
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        padding: 6px 4px;
      }
      .th {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
        font-size: .75rem;
        font-weight: bolder;
        line-height: 1.3;
      }
      .td {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
        font-size: .9rem;
      }
      .highlight {
        font-weight: bolder;
      }
    }
    .text-shadow {text-shadow: 1px 2px 4px rgba($color: #d25e00, $alpha: .85);};
    .text-justify {text-align: justify;}
  }

  .lucky-wheel-container {
    @include container-styles;
  }

  :deep(.lucky-wheel-container) {
    @include container-styles;
  }

  .wheel-container {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 360px;
    max-height: 360px;
    img, svg#lucky-wheel-stars {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    svg {
      width: 100%;
      height: 100%;
      transition: transform 5s cubic-bezier(0.17, 0.67, 0.12, 0.99);
      transform-origin: center center;
    }
  }

  #lucky-wheel-content {

    .st0 {
      fill: #46bd74;
    }

    .st1 {
      fill: #ffac41;
    }

    .st2 {
      stroke-dasharray: 0 12.7454948;
    }

    .st2, .st3, .st4, .st5 {
      fill: none;
      stroke: #ffeb3b;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 6px;
    }

    .st6 {
      fill: #814aff;
    }

    .st4 {
      stroke-dasharray: 0 13.0877247;
    }

    .st7, .st8 {
      fill: #fff;
    }

    .st5 {
      stroke-dasharray: 0 13.0880995;
    }

    .st9, .st10 {
      glyph-orientation-vertical: 0deg;
      text-orientation: upright;
      writing-mode: tb;
    }

    .st9, .st11 {
      fill: #e73828;
      font-family: Roboto-Black, Roboto;
      font-size: 32px;
      font-weight: 800;
    }

    .st8 {
      font-family: NotoSansCJKtc-Bold-B5pc-H, 'Noto Sans CJK TC';
      font-size: 24px;
      font-weight: 700;
    }

    .st12 {
      fill: #ff7491;
    }

    .st13 {
      fill: #2ab4ff;
    }
  }

  /* 定義淡入淡出動畫 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.15s ease-in-out;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to,
  .fade-leave-from {
    opacity: 1;
  }


  .table-outer {
    max-height: 300px;
    overflow-y: auto;
    background-color: #cceef4;
  }

  //carousel-outer
  .carousel-outer {
    max-width: 280px;
    border-radius: 12px;
  }

  .carousel-indicators {
    margin-bottom: 4.5rem;
    button {
      width: 8px;
      height: 8px;
      margin-right: 4px;
      margin-left: 4px;
      border-radius: 50%;
    }
  }
  .carousel-item {
    label {
      height:64px;
      padding-top:8px;
      font-size: .875rem;
      font-weight: 500;
      .text-danger {
        font-size: 1.1rem;
      }
    }
    .bg-gradient-black {
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:64px;
    }
  }
  .carousel-caption {
    bottom: 5.25rem;
    padding-bottom: 1rem;
    left: 10%;
    right: 10%;
  }
  .carousel-control-prev, .carousel-control-next {
    width: 10%;
    bottom:64px;
  }

  .card ul li {
    font-size: .875rem;
  }

  .separator-row {
    height: 40px;
    opacity: 0.5;
  }
  .wheel-wrapper {
    isolation: isolate;
    contain: layout; /* Changed from strict to layout */
    position: relative;
    z-index: 1;
    width: 100%; /* Ensure wrapper takes full width */
    height: auto; /* Allow height to adjust to content */
    overflow: visible; /* Let content be visible */
  }


  .finished {
    width: 100%;
    max-width: 160px;
    height: auto;
    > * {
      width: 100%;
      height: auto;
      padding-top: 100%;
      background-image :url('@/assets/img/Confetti3.png');
    }

  }
  </style>
  